import {h, Fragment} from "preact"
import { useAppStateSelector, useSelectedFiltersCount, useSort, pick, useConfig } from "@nosto/preact"
import { sortOptions } from "../config"
import Icon from "./elements/Icon"
import Select from "./elements/Select"
import { toggleButtonId } from "./Sidebar"

function ToggleMobileSidebarButton({ selectedFiltersCount, className }) {
    return (
        <label
            for={toggleButtonId}
            className={`ns-filters ns-d-inline-flex ns-text-align-center ns-align-items-center body-l text-t-brand-foreground-secondary cursor-pointer transition-[color] duration-300 ease-out hover:text-t-brand-foreground`}
        >
            <span>Filter by</span>
            {/* {selectedFiltersCount > 0 && (
                <span className="ns-total-count ns-d-inline-block ns-text-align-center ns-font-3 ns-font-bold ns-color-white ns-background-primary ns-ml-1">
                    {selectedFiltersCount}
                </span>
            )} */}
            <svg width="10" height="10" aria-hidden='true' focusable='false' role='presentation' class='icon icon-caret' viewBox='0 0 10 10' fill='none'>
                <path d="M9.58337 2.9165L5.00004 6.92692L0.416707 2.9165" stroke="currentColor" stroke-width="0.666667"/>
            </svg>
        </label>
    )
}

export default function Toolbar() {
    const { shopifyStoreSettings } = useConfig()
    const { loading, query, response, pageType } = useAppStateSelector(state =>
        pick(state, "loading", "query", "response", "pageType")
    )
    const { activeSort, setSort } = useSort(sortOptions)
    const selectedFiltersCount = useSelectedFiltersCount()
    const { showPrice  } = shopifyStoreSettings?.product || {}

    const handleSortChange = event => {
        setSort(event.target.value)
    }

    const docCount = response.products?.total ?? 0

    // const totalSummary = pageType === "category" ? `${docCount} products` : `'${query.query}' - ${docCount} results`
    const totalSummary = docCount === 1 ? `${docCount} Piece` : `${docCount} Pieces`

    
    let options = sortOptions.map(o => ({ value: o.id, label: o.value.name }))
    if (!showPrice) {
        options = options.filter(({value, label}) => !(value.includes('price') || label.includes('price')))
    }

    return (
        <div
            class="ns-header-controls ns-d-flex ns-justify-content-between ns-align-items-center"
            style={loading ? "opacity: 0.3; justify-content: end !important;" : ""}
        >
            <div class="ns-d-flex ns-align-items-center gap-x-3.5 h-sm-forms-inputheight">
                <ToggleMobileSidebarButton
                    selectedFiltersCount={selectedFiltersCount}
                />
                <Select
                    value={activeSort}
                    onChange={e => handleSortChange(e)}
                    className="ns-selection-dropdown-sort-menu"
                    options={options}
                    label={"Sort by"}
                />
            </div>
            {!loading && (
                <div class="caption leading-[1.25] font-normal text-t-brand-foreground-secondary lg:text-[0.875rem] lg:leading-none tracking-[0.03em]">
                    <span
                        class="ns-d-md-block ns-text-align-right"
                        data-nosto-element="totalResults"
                    >
                        {totalSummary}
                    </span>
                </div>
            )}
        </div>
    )
}
